import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';

@Component({
  selector: 'app-ana-cantieri',
  templateUrl: './ana-cantieri.component.html',
  styleUrls: ['./ana-cantieri.component.css']
})
export class AnaCantieriComponent extends NicaMaster implements OnInit {

  @Input() showTitle: boolean = true;
  @Output() rowSelected = new EventEmitter<any>();
  help: any;
  buttonCustom2: any[] = []
  constructor(private activateRoute: ActivatedRoute,
    public spinner: NgxSpinnerService,

    public apiservice: Apiservice,


    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,
    private changeDetector?: ChangeDetectorRef


  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );
  }


  ngOnInit() {

    if (this.itemData) {
      this.currentTabId = this.itemData[0].componentName,
        this.currentTabName = this.itemData[0].componentName
      this.setGlobalVariableFromParams(this.itemData[0])



    } else {
      this.activateRoute.queryParams.subscribe(params => {
        this.params = params

        console.log("Parametri=", this.params);


        this.currentTabId = params.currentTabId,
          this.currentTabName = params.currentTabName



        this.setGlobalVariableFromParams(params);


      })
    }
  }

  formItemsEventCantiere(e) {

    if (e.name == "onValueChanged") {


      // if (e.campo.dataField == 'comune') {
      //   this.formAnagrafica.formRefreshInputData('stato', 'IT');
      // }
      if (e.campo.dataField == 'stato') {
        if (e.formData.stato !== 'IT') {
          this.formAnagrafica.formRefreshInputData('provincia', null);
          this.formAnagrafica.formRefreshInputData('istat', null);
          this.formAnagrafica.itemOption('datiCantiere.provincia', 'disabled', true);
          this.formAnagrafica.itemOption('datiCantiere.istat', 'disabled', true);
        } else {
          this.formAnagrafica.itemOption('datiCantiere.provincia', 'disabled', false);
          this.formAnagrafica.itemOption('datiCantiere.istat', 'disabled', false);
        }
        this.changeDetector.detectChanges()
      }



    }


    if (e.name == "selectedItemLista") {
      // if (e.campo.dataField == 'siglaProvincia') {
      //   this.formAnagrafica.formRefreshInputData('stato', 'IT');
      // }

      if (e.campo.dataField == 'stato') {
        if (e.formData.stato !== 'IT') {
          this.formAnagrafica.formRefreshInputData('provincia', null);
          this.formAnagrafica.formRefreshInputData('istat', null);
          this.formAnagrafica.itemOption('datiCantiere.provincia', 'disabled', true);
          this.formAnagrafica.itemOption('datiCantiere.istat', 'disabled', true);
        } else {
          this.formAnagrafica.itemOption('datiCantiere.provincia', 'disabled', false);
          this.formAnagrafica.itemOption('datiCantiere.istat', 'disabled', false);
        }
        this.changeDetector.detectChanges()
      }
    }


  }

}
